import { EditTariffParams } from 'types/services';
import { m8API } from 'services/production/m8';

export const editTariff = async (params: EditTariffParams): Promise<void> => {
  const { product, tariff, formValues } = params;

  if (tariff) {
    await m8API.admin.updatePrice({
      idPrice: tariff.id,
      amount: Number(formValues.cost),
      endDate: formValues.expiresAt,
    });
  } else {
    await m8API.admin.addPriceToComponent({
      type: product.type,
      amount: Number(formValues.cost),
      endDate: formValues.expiresAt,
    });
  }
};
